import React from 'react';
import { Link, useParams } from 'react-router-dom';
import './LandingPage.css';
import { useLanguage } from '../contexts/LanguageContext';
import { getArticleBySlug } from '../utils/blogUtils';

const ArticlePage = () => {
  const { t, isRTL, currentLanguage } = useLanguage();
  const { slug } = useParams();
  const article = getArticleBySlug(slug, t);

  // Map language codes to locale codes for date formatting
  const localeMap = {
    en: 'en-US',
    es: 'es-ES',
    fr: 'fr-FR',
    he: 'he-IL',
    zh: 'zh-CN'
  };
  const locale = localeMap[currentLanguage] || 'en-US';

  if (!article) {
    return (
      <div className="landing-container" dir={isRTL ? 'rtl' : 'ltr'}>
        <header className="landing-header">
          <h1>{t('articleNotFound') || 'Article Not Found'}</h1>
        </header>
        <main className="landing-main" style={{ textAlign: 'center', maxWidth: '800px', margin: '0 auto' }}>
          <p style={{ fontSize: '1.1rem', color: '#666', marginBottom: '2rem' }}>
            {t('articleNotFoundMessage') || 'The article you are looking for does not exist.'}
          </p>
          <div style={{ marginTop: 32 }}>
            <Link to="/blog" className="btn btn-primary">{t('backToBlog') || 'Back to Blog'}</Link>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="landing-container" dir={isRTL ? 'rtl' : 'ltr'}>
      <header className="landing-header">
        <div style={{ marginBottom: '1rem' }}>
          <Link
            to="/blog"
            style={{
              color: '#386641',
              textDecoration: 'none',
              fontSize: '0.9rem',
              fontWeight: 500
            }}
          >
            ← {t('backToBlog') || 'Back to Blog'}
          </Link>
        </div>
        <h1 style={{ fontSize: '2.5rem', marginBottom: '0.5rem' }}>{article.title}</h1>
        <p style={{
          color: '#666',
          fontSize: '1rem',
          fontStyle: 'italic',
          marginBottom: '1rem'
        }}>
          {new Date(article.date).toLocaleDateString(locale, {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })} • {article.author}
        </p>
      </header>
      <main className="landing-main" style={{ textAlign: isRTL ? 'right' : 'left', maxWidth: '800px', margin: '0 auto' }}>
        <article
          className="blog-article-content"
          style={{
            padding: '2rem 0',
            lineHeight: '1.8',
            fontSize: '1.1rem',
            color: '#333'
          }}
          dangerouslySetInnerHTML={{ __html: article.content }}
        />
        <div style={{
          marginTop: '3rem',
          paddingTop: '2rem',
          borderTop: '1px solid #eee',
          textAlign: 'center'
        }}>
          <Link to="/blog" className="btn btn-secondary" style={{ marginRight: '1rem' }}>
            {t('backToBlog') || 'Back to Blog'}
          </Link>
          <Link to="/home" className="btn btn-primary">
            {t('backToHome')}
          </Link>
        </div>
      </main>
      <footer className="landing-footer">
        <div className="footer-links">
          <Link to="/about">{t('about')}</Link>
          <Link to="/privacy">{t('privacyPolicy')}</Link>
          <Link to="/terms">{t('termsOfService')}</Link>
          <Link to="/support">{t('supportTitle') || 'Support'}</Link>
        </div>
        <p>&copy; {new Date().getFullYear()} SafaCards App. {t('allRightsReserved')}</p>
      </footer>
    </div>
  );
};

export default ArticlePage;

